/* ============================================================
   JuxtaCharge — product page JS
   ============================================================ */
(function () {
  if (!window.JuxtaTheme) return;

  JuxtaTheme.register('juxta-product-main', {
    init(el) {
      /* ---------------- Gallery (CSS scroll-snap) ---------------- */
      const track = el.querySelector('[data-gallery-track]');
      const dots  = el.querySelectorAll('[data-gallery-dot]');
      const prev  = el.querySelector('[data-gallery-prev]');
      const next  = el.querySelector('[data-gallery-next]');
      const galleryHandlers = [];
      if (track && dots.length) {
        const TOTAL = dots.length;
        let current = 0;
        let autoTimer;
        const setActive = (idx) => {
          current = (idx + TOTAL) % TOTAL;
          track.scrollTo({ left: current * track.offsetWidth, behavior: 'smooth' });
          dots.forEach((d, i) => d.classList.toggle('active', i === current));
        };
        const startAuto = () => { autoTimer = setInterval(() => setActive(current + 1), 5000); };
        const stopAuto = () => clearInterval(autoTimer);

        const onPrev = () => { stopAuto(); setActive(current - 1); startAuto(); };
        const onNext = () => { stopAuto(); setActive(current + 1); startAuto(); };
        if (prev) { prev.addEventListener('click', onPrev); galleryHandlers.push({ el: prev, evt: 'click', h: onPrev }); }
        if (next) { next.addEventListener('click', onNext); galleryHandlers.push({ el: next, evt: 'click', h: onNext }); }
        dots.forEach((dot, i) => {
          const h = () => { stopAuto(); setActive(i); startAuto(); };
          dot.addEventListener('click', h);
          galleryHandlers.push({ el: dot, evt: 'click', h });
        });
        let sd;
        const onScroll = () => {
          clearTimeout(sd);
          sd = setTimeout(() => {
            const idx = Math.round(track.scrollLeft / track.offsetWidth);
            if (idx !== current) { current = idx; dots.forEach((d, i) => d.classList.toggle('active', i === current)); }
          }, 60);
        };
        track.addEventListener('scroll', onScroll);
        galleryHandlers.push({ el: track, evt: 'scroll', h: onScroll });
        startAuto();
        el.__galleryStopAuto = stopAuto;
      }

      /* ---------------- Bundle / quantity selector ---------------- */
      const qtyCards = el.querySelectorAll('[data-qty-card]');
      const mainPrice   = el.querySelector('[data-main-price]');
      const comparePrice= el.querySelector('[data-compare-price]');
      const saveBadge   = el.querySelector('[data-save-badge]');
      const atcBtn      = el.querySelector('[data-atc-btn]');
      const qtyInput    = el.querySelector('[data-qty-input]');
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const bundleHandlers = [];

      qtyCards.forEach((card) => {
        const h = () => {
          qtyCards.forEach((c) => c.classList.remove('active'));
          card.classList.add('active');
          const price = card.dataset.price;
          const compare = card.dataset.compare;
          const save = card.dataset.save;
          const qty = card.dataset.qty;
          if (mainPrice)    mainPrice.textContent    = '$' + price;
          if (comparePrice) {
            if (compare && compare !== '' && compare !== '0' && compare !== '0.0' && compare !== '0.00') {
              comparePrice.textContent = '$' + compare;
              comparePrice.style.display = '';
            } else {
              comparePrice.textContent = '';
              comparePrice.style.display = 'none';
            }
          }
          if (saveBadge)    saveBadge.textContent    = save || '';
          if (qtyInput)     qtyInput.value           = qty;
          if (atcBtn)       atcBtn.textContent       = 'ADD TO CART  $' + price;
          if (stickyPrice)  stickyPrice.textContent  = '$' + price;
        };
        card.addEventListener('click', h);
        bundleHandlers.push({ el: card, h });
      });

      /* ---------------- Info accordion (How to Use / Shipping / Guarantee) ---------------- */
      const infoAccordionBtns = el.querySelectorAll('.info-accordion__btn');
      const accordionHandlers = [];
      infoAccordionBtns.forEach((btn) => {
        const h = () => {
          const item = btn.closest('.info-accordion__item');
          const isOpen = item.classList.contains('open');
          el.querySelectorAll('.info-accordion__item').forEach((i) => i.classList.remove('open'));
          if (!isOpen) item.classList.add('open');
        };
        btn.addEventListener('click', h);
        accordionHandlers.push({ el: btn, h });
      });

      /* ---------------- Variant picker (Shopify variant support) ---------------- */
      const variantPickers = el.querySelectorAll('[data-variant-option]');
      const variantPickerHandlers = [];
      const variantInput = el.querySelector('[data-variant-id-input]');
      const formWrap = el.querySelector('[data-product-form-wrap]');
      const form = formWrap ? formWrap.querySelector('form') : el.querySelector('form[action*="/cart/add"]');
      const productJsonEl = el.querySelector('[data-product-json]');
      let productData = null;
      if (productJsonEl) {
        try { productData = JSON.parse(productJsonEl.textContent); } catch(e) {}
      }
      const selectedOptions = {};
      variantPickers.forEach((btn) => {
        const h = () => {
          const group = btn.closest('[data-option-group]');
          const idx = group ? group.dataset.optionIndex : '0';
          group.querySelectorAll('[data-variant-option]').forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
          selectedOptions[idx] = btn.dataset.value;
          const labelSelected = group.previousElementSibling && group.previousElementSibling.querySelector('.variant-label__selected');
          if (labelSelected) labelSelected.textContent = btn.dataset.value;
          updateSelectedVariant();
        };
        btn.addEventListener('click', h);
        variantPickerHandlers.push({ el: btn, h });
        if (btn.classList.contains('active')) {
          const group = btn.closest('[data-option-group]');
          const idx = group ? group.dataset.optionIndex : '0';
          selectedOptions[idx] = btn.dataset.value;
        }
      });

      function updateSelectedVariant() {
        if (!productData || !productData.variants) return;
        const match = productData.variants.find((v) => {
          return (v.options || []).every((opt, i) => selectedOptions[i] == null || selectedOptions[i] === opt);
        });
        if (match && variantInput) {
          variantInput.value = match.id;
          if (mainPrice) mainPrice.textContent = '$' + (match.price / 100).toFixed(2);
          if (match.compare_at_price && comparePrice) comparePrice.textContent = '$' + (match.compare_at_price / 100).toFixed(2);
          if (atcBtn && !el.querySelector('.qty-card.active')) {
            atcBtn.textContent = match.available ? 'ADD TO CART  $' + (match.price / 100).toFixed(2) : 'Sold Out';
            atcBtn.disabled = !match.available;
          }
        }
      }

      /* ---------------- Form AJAX submit ---------------- */
      let formHandler = null;
      if (form) {
        formHandler = async (e) => {
          e.preventDefault();
          if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }
          try {
            const fd = new FormData(form);
            await JuxtaTheme.addToCart(fd);
            const cart = await JuxtaTheme.fetchCart();
            JuxtaTheme.updateCartCount(cart.item_count);
            if (atcBtn) { atcBtn.textContent = 'Added to Cart ✓'; setTimeout(() => { atcBtn.disabled = false; }, 1200); }
            JuxtaTheme.openCart();
          } catch (err) {
            if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
            console.warn(err);
          }
        };
        form.addEventListener('submit', formHandler);
      }

      /* ---------------- Sticky ATC visibility ---------------- */
      const stickyAtc = document.getElementById('StickyAtc');
      const atcSentinel = el.querySelector('[data-atc-sentinel]');
      let observer = null;
      if (stickyAtc && atcSentinel) {
        observer = new IntersectionObserver(
          ([entry]) => stickyAtc.classList.toggle('visible', !entry.isIntersecting),
          { threshold: 0.1 }
        );
        observer.observe(atcSentinel);
      }
      // Sticky ATC button -> trigger form submit
      const stickyBtn = stickyAtc && stickyAtc.querySelector('[data-sticky-atc-btn]');
      let stickyBtnHandler = null;
      if (stickyBtn && form) {
        stickyBtnHandler = (e) => { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); };
        stickyBtn.addEventListener('click', stickyBtnHandler);
      }

      el.__juxtaProductCleanup = () => {
        galleryHandlers.forEach(({ el, evt, h }) => el.removeEventListener(evt, h));
        if (el.__galleryStopAuto) el.__galleryStopAuto();
        bundleHandlers.forEach(({ el, h }) => el.removeEventListener('click', h));
        accordionHandlers.forEach(({ el, h }) => el.removeEventListener('click', h));
        variantPickerHandlers.forEach(({ el, h }) => el.removeEventListener('click', h));
        if (form && formHandler) form.removeEventListener('submit', formHandler);
        if (observer) observer.disconnect();
        if (stickyBtn && stickyBtnHandler) stickyBtn.removeEventListener('click', stickyBtnHandler);
      };
    },

    destroy(el) {
      if (el.__juxtaProductCleanup) el.__juxtaProductCleanup();
    }
  });
})();
